var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"date-picker"}},[_c('el-date-picker',_vm._b({attrs:{"clearable":_vm.clearable,"align":_vm.align,"size":_vm.size,"picker-options":_vm.pickerOptions},on:{"change":_vm.onChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'el-date-picker',_vm.buildAttrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }